import axios from "axios";

export const api = axios.create({ baseURL: `${process.env.REACT_APP_BACKEND_URL}/api` });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use((r) => r, (e) => {
  if (e?.response?.status === 401 && localStorage.getItem("token") && !e.config?.url?.includes("/auth/login")) {
    localStorage.removeItem("token");
    window.location.assign("/login");
  }
  return Promise.reject(e);
});

export function errMsg(e) {
  const d = e?.response?.data?.detail;
  if (!d) return e?.message || "Une erreur est survenue";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x.msg || JSON.stringify(x)).join(" ");
  return String(d);
}

export const PayBadge = ({ method }) => {
  const m = (method || "").toUpperCase();
  const cls = m.includes("WAVE") ? "bg-[#1dc3f2] border-[#1dc3f2]" : m.includes("ORANGE") || m === "OM" ? "bg-[#ff7900] border-[#ff7900]" : "bg-white border-slate-300";
  return <span className={`inline-block rounded border px-1.5 py-0.5 text-[11px] font-semibold text-black ${cls}`} data-testid="pay-badge">{method}</span>;
};
export const fmt = (n) => new Intl.NumberFormat("fr-FR", { maximumFractionDigits: 2 }).format(n ?? 0);
export const fmtMoney = (n) => new Intl.NumberFormat("fr-FR", { maximumFractionDigits: 0 }).format(Math.round(n ?? 0));
export const fmtDate = (s) => new Date(s).toLocaleString("fr-FR", { dateStyle: "short", timeStyle: "short" });
export const ROLE_LABEL = { admin: "Administrateur", gestionnaire: "Gestionnaire", vendeur: "Vendeur" };
export const photoUrl = (f) => `${process.env.REACT_APP_BACKEND_URL}/api/fabrics/${f.id}/photo?auth=${localStorage.getItem("token")}&v=${f.photo_v || ""}`;
export const logoUrl = (v) => `${process.env.REACT_APP_BACKEND_URL}/api/settings/logo?auth=${localStorage.getItem("token")}&v=${v}`;
export const UNIT_LABEL = { m: "Mètre", kg: "Kilogramme", rouleau: "Pièce / rouleau" };
export const qtyCols = (x) => {
  const unit = x.unit || x.fabric?.unit || "m";
  if (unit === "rouleau") return { pieces: x.pieces ?? x.quantity, measure: x.measure ?? (x.fabric?.roll_length ? x.quantity * x.fabric.roll_length : null), munit: "m" };
  return { pieces: x.pieces ?? null, measure: x.measure ?? x.quantity, munit: x.measure_unit || unit };
};
export const can = (user, module, action) => user?.role === "admin" || !!user?.effective_permissions?.[module]?.[action];
export const renameDocument = async (path, current) => {
  const number = window.prompt("Nouveau numéro de document :", current);
  if (number === null || !number.trim() || number.trim().toUpperCase() === current) return null;
  const { data } = await api.patch(path, { number: number.trim(), reason: "changement de numéro par l'administrateur" });
  return data.number;
};
